<div class="grid">
  <div class="input-field col-12 md:col-8">
    <label>Tipo *</label>
    <p-dropdown [options]="actionTypes" [(ngModel)]="form.actionType" optionLabel="label" optionValue="value"
      appendTo="body" [filter]="true" filterBy="label" (onChange)="onTypeChange()"></p-dropdown>
  </div>
  <div class="input-field col-12 md:col-4">
    <label>Orden</label>
    <input type="number" pInputText [(ngModel)]="form.sortOrder" class="w-full" />
  </div>

  <div *ngIf="form.actionType === 'CallQueue'" class="input-field col-12">
    <label>Cola *</label>
    <p-dropdown [options]="queues" [(ngModel)]="form.queueId" optionLabel="name" optionValue="id"
      appendTo="body" [filter]="true" filterBy="name" placeholder="Seleccione una cola"></p-dropdown>
  </div>

  <ng-container *ngIf="form.actionType === 'CallExtension'">
    <div class="input-field col-12">
      <label>Número de extensión *</label>
      <input pInputText [(ngModel)]="form.extensionNumber" class="w-full" />
    </div>
    <div class="input-field col-12 md:col-6">
      <label>Application</label>
      <input pInputText [(ngModel)]="form.application" class="w-full" placeholder="opcional" />
    </div>
    <div class="input-field col-12 md:col-6">
      <label>Data</label>
      <input pInputText [(ngModel)]="form.data" class="w-full" placeholder="opcional" />
    </div>
    <div class="input-field col-12">
      <label>Caller ID</label>
      <input pInputText [(ngModel)]="form.callerId" class="w-full" placeholder="opcional" />
    </div>
  </ng-container>

  <div *ngIf="form.actionType === 'PlayAudio'" class="input-field col-12">
    <label>Nombre del audio *</label>
    <input pInputText [(ngModel)]="form.audioFilename" class="w-full" placeholder="ej. welcome" />
  </div>

  <ng-container *ngIf="form.actionType === 'WaitForInput'">
    <div class="input-field col-12 md:col-4">
      <label>Audio del prompt</label>
      <input pInputText [(ngModel)]="form.audioFilename" class="w-full" placeholder="opcional" />
    </div>
    <div class="input-field col-12 md:col-4">
      <label>Timeout (s) *</label>
      <input type="number" pInputText [(ngModel)]="form.timeoutSeconds" class="w-full" />
    </div>
    <div class="input-field col-12 md:col-4">
      <label>Máx. dígitos *</label>
      <input type="number" pInputText [(ngModel)]="form.maxDigits" class="w-full" />
    </div>
  </ng-container>

  <div *ngIf="form.actionType === 'Wait'" class="input-field col-12">
    <label>Segundos de espera *</label>
    <input type="number" pInputText [(ngModel)]="form.waitSeconds" class="w-full" placeholder="ej. 3" />
  </div>

  <div *ngIf="form.actionType === 'SendDtmf'" class="input-field col-12">
    <label>Pulsación DTMF a enviar *</label>
    <input pInputText [(ngModel)]="form.dtmfDigit" class="w-full" maxlength="8" placeholder="ej. 1 o *#" />
  </div>

  <div *ngIf="form.actionType === 'ReadText'" class="input-field col-12">
    <label>Texto a leer *</label>
    <textarea pInputTextarea [(ngModel)]="form.ttsText" class="w-full" rows="3"
              placeholder="Texto que leerá el motor TTS"></textarea>
  </div>

  <div *ngIf="form.actionType === 'SetCallerId'" class="input-field col-12">
    <label>Nombre del llamante *</label>
    <input pInputText [(ngModel)]="form.callerIdName" class="w-full" maxlength="128"
           placeholder="ej. Atención al cliente" />
  </div>

  <div *ngIf="form.actionType === 'CallerNumberIs'" class="input-field col-12">
    <label>Número a comprobar *</label>
    <input pInputText [(ngModel)]="form.callerNumber" class="w-full" maxlength="40"
           placeholder="ej. 600123456" />
  </div>

  <ng-container *ngIf="form.actionType === 'CumpleHorario'">
    <div class="input-field col-12 md:col-6">
      <label>Hora de inicio *</label>
      <input type="time" pInputText [(ngModel)]="form.startTime" class="w-full" />
    </div>
    <div class="input-field col-12 md:col-6">
      <label>Hora de fin *</label>
      <input type="time" pInputText [(ngModel)]="form.endTime" class="w-full" />
    </div>
    <div class="input-field col-12">
      <label>Días de la semana *</label>
      <p-multiSelect [options]="daysOptions" [(ngModel)]="selectedDays" optionLabel="label" optionValue="value"
        appendTo="body" display="chip" placeholder="Seleccione los días"
        [showHeader]="false" styleClass="w-full"></p-multiSelect>
    </div>
    <div class="col-12">
      <small class="text-color-secondary">Si la hora de fin es anterior a la de inicio, el rango cruza la medianoche (ej. 22:00–06:00).</small>
    </div>
  </ng-container>

</div>

<div class="flex justify-content-end gap-2 mt-4">
  <p-button label="Cancelar" severity="secondary" (click)="cancel()"></p-button>
  <p-button label="Aceptar" icon="pi pi-check" (click)="save()"></p-button>
</div>
